import { media, styled } from '@styles';
import { Button } from '@components/atoms/Button';

import chevronLeftImage from 'images/chevron_left.svg';
import chevronRightImage from 'images/chevron_right.svg';

export const Wrapper = styled.div`
  margin-top: 140px;
  position: relative;
  ${media.largeScreen`
    margin-top: 98px;
  `}
  ${media.mediumScreen`
    margin-top: 77px;
  `}
  ${media.smallScreen`
    margin-top: 55px;
  `}

  .slick-arrow {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    border-radius: 50%;
    width: 56px;
    height: 56px;
    color: transparent;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    box-shadow: 0px 4px 34px rgba(0, 0, 0, 0.08);
    z-index: 1;
    ${media.largeScreen`
      top: 63%;
      width: 50px;
      height: 50px;
    `}
    ${media.smallScreen`
      top: 30vw;
      width: 40px;
      height: 40px;
    `}
  }

  .slick-prev {
    background-image: url(${chevronLeftImage});
    left: -70px;
    ${media.largeScreen`
      left: -102px;
    `}
    ${media.mediumScreen`
      left: -5px;
    `}
    ${media.smallScreen`
      left: -14px;
    `}
  }
  .slick-next {
    background-image: url(${chevronRightImage});
    right: -70px;
    ${media.largeScreen`
      right: -102px;
    `}
    ${media.mediumScreen`
      right: -5px;
    `}
    ${media.smallScreen`
      right: -14px;
    `}
  }
`;

export const Slide = styled.div`
  display: flex !important;
  padding: 0 10px;
  ${media.mediumScreen`
    flex-direction: column;
    padding: 0 67px;
  `}
  ${media.smallScreen`
    padding: 0 10px;
  `}
`;

export const ImageWrapper = styled.div`
  width: 56.5%;
  margin-right: 125px;
  flex-shrink: 0;
  ${media.largeScreen`
    width: 53.5%;
    margin-right: 58px;
  `}
  ${media.mediumScreen`
    width: 100%;
    margin-right: 0;
  `}
  ${media.smallScreen`
  `}
`;

export const Image = styled.div`
  width: 100%;
  height: 30vw;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  ${media.mediumScreen`
    height: 48vw;
  `}
  ${media.smallScreen`
    height: 60vw;
  `}
`;

export const TextWrapper = styled.div`
  margin-top: 72px;
  ${media.largeScreen`
    margin-top: 0;
  `}
  ${media.mediumScreen`
    margin-top: 33px;
    padding: 0 50px;
  `}
  ${media.smallScreen`
    padding: 0;
    margin-top: 25px;
  `}
`;

export const Tag = styled.div`
  margin-bottom: 10px;
  font-family: ${(props) => props.theme.typography.extraFontFamily};
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 160%;
  color: ${(props) => props.theme.colors.graySemi};
  ${media.largeScreen`
    margin-bottom: 6px;
    font-size: 16px;
  `}
  ${media.smallScreen`
    font-size: 12px;
  `}
`;

export const Title = styled.div`
  * {
    font-family: ${(props) => props.theme.typography.thinFontFamily};
    font-style: normal;
    font-weight: normal;
    font-size: 36px;
    line-height: 140%;
    color: ${(props) => props.theme.colors.baseFont};
    ${media.largeScreen`
      font-size: 30px;
    `}
    ${media.smallScreen`
      font-size: 24px;
    `}
  }
`;

export const Description = styled.div`
  p {
    margin-top: 34px;
    font-family: ${(props) => props.theme.typography.extraFontFamily};
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 180%;
    color: #666f73;
    ${media.largeScreen`
      margin-top: 24px;
      font-size: 16px;
      line-height: 180%;
    `}
    ${media.smallScreen`
      margin-top: 10px;
      font-size: 14px;
      line-height: 170%;
    `}
  }
`;

export const ReadButton = styled(Button)`
  height: 68px;
  margin-top: 74px;
  span {
    font-family: ${(props) => props.theme.typography.baseFontFamily};
  }
  ${media.largeScreen`
    height: 48px;
    margin-top: 32px;
  `}
  ${media.mediumScreen`
    display: block;
    margin: 60px auto 0;
  `}
  ${media.smallScreen`
    margin-top: 48px;
    height: 48px;
  `}
`;
